import React from 'react';
import useRelationship from 'Hooks/useRelationship';
import DataContainer from 'Components/UI/DataContainer';
import { OutcomeInvestmentDetailsOverviewLayout } from './OutcomeInvestmentDetailsOverviewLayout';

const OutcomeInvestmentDetailsOverviewContainer = ({ relationship }) => {
  const {
    loading,
    loadingError,
    collection,
  } = useRelationship(
    relationship,
  );

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      component={OutcomeInvestmentDetailsOverviewLayout}
      componentProps={{
        collection,
      }}
    />
  );
};

export { OutcomeInvestmentDetailsOverviewContainer };
